import { Button, Col, Form, Row } from 'react-bootstrap';

// fix_issue3.md #6 - configurable specification sheet, editable by the owner/partner. `form` must
// carry `specifications: [{label,value}]`.
export function specificationsPayload(form) {
  return (form.specifications || []).filter((s) => s.label || s.value);
}

export default function SpecificationsEditor({ form, setForm }) {
  const specs = form.specifications || [];
  const setSpec = (index, key) => (e) => setForm((prev) => ({
    ...prev,
    specifications: (prev.specifications || []).map((s, i) => (i === index ? { ...s, [key]: e.target.value } : s))
  }));
  const addSpec = () => setForm((prev) => ({ ...prev, specifications: [...(prev.specifications || []), { label: '', value: '' }] }));
  const removeSpec = (index) => setForm((prev) => ({ ...prev, specifications: (prev.specifications || []).filter((_, i) => i !== index) }));

  return (
    <Form.Group className="mb-3">
      <Form.Label>Specifications</Form.Label>
      {specs.map((spec, index) => (
        <Row key={index} className="g-2 mb-2">
          <Col xs={5}><Form.Control size="sm" placeholder="Label (e.g. Facing)" value={spec.label} onChange={setSpec(index, 'label')} /></Col>
          <Col xs={5}><Form.Control size="sm" placeholder="Value (e.g. East)" value={spec.value} onChange={setSpec(index, 'value')} /></Col>
          <Col xs={2}><Button size="sm" variant="outline-danger" onClick={() => removeSpec(index)} aria-label={`Remove specification ${index + 1}`}>✕</Button></Col>
        </Row>
      ))}
      <Button size="sm" variant="outline-secondary" onClick={addSpec}>+ Add specification</Button>
    </Form.Group>
  );
}
